<template>
  <div class="box vh-140">
    <div class="box-header">
      <i class="fa fa-th-large"></i>
      <h3 class="box-title">职务列表</h3>
      <div class="box-tools">
        <el-button size="small" type="primary" @click="toEditJob()" round><i class="fa fa-plus"></i> 添加职务</el-button>
      </div>
    </div>
    <div class="box-body">
      <el-table class="list-table" ref="multipleTable" :data="jobList" border tooltip-effect="dark"
                :header-cell-style="{ background: '#eef1f6', color: '#606266' }">
        <template slot="empty">
          <div class="no-data">暂无数据！</div>
        </template>
        <el-table-column type="index" label="序号" width="60"></el-table-column>
        <el-table-column prop="name" label="名称" width="120"></el-table-column>
        <el-table-column prop="weight" label="权重" width="120"></el-table-column>
        <el-table-column prop="description" label="描述" width="120"></el-table-column>
        <el-table-column fixed="right" label="操作" min-width="100">
          <template slot-scope="scope">
            <el-button @click="toEditJob(scope.row.id)" type="text" size="small"><i class="fa fa-edit"></i> 编辑</el-button>
            <el-button @click="deleteJob(scope.row.id)" type="text" size="small"><i class="fa fa-trash-o"></i> 删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog :title="isEdit?'编辑职务':'新增职务'" :visible.sync="dialogVisible" :destroy-on-close="true" width="450px" class="form-dialog">
      <el-form :model="form" :rules="rules" ref="form" label-width="80px">
        <el-form-item label="上级" prop="parentId" v-if="false">
          <el-cascader :options="options" v-model="parentIdEcho" :props="props" clearable change-on-select style="width: 70%"></el-cascader>
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入职务名称" style="width: 70%"></el-input>
        </el-form-item>
        <el-form-item label="描述">
          <el-input type="textarea" v-model="form.description" placeholder="请输入职务描述"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
          <el-button @click="dialogVisible = false" ><i class="fa fa-close"></i> 取 消</el-button>
          <el-button type="primary" @click="saveJob()"><i class="fa fa-save"></i> 确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { fetchList, get, save, update, remove } from '@/api/system/job'
import { handleConfirm } from '@utils/confirm'

export default {
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      fetchList().then(resp => {
        this.jobList = resp.data.result
      })
    },
    saveJob() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.form.parentId = this.parentIdEcho[this.parentIdEcho.length - 1]
          this.form.parentIds = this.parentIdEcho.join(',')
          this.form.parentId = this.form.parentId ? this.form.parentId : ''
          this.form.parentIds = this.form.parentIds ? this.form.parentIds : ''
          if (this.isEdit) {
            update(this.form).then(resp => {
              this.submitCallback(resp)
            })
          } else {
            save(this.form).then(resp => {
              this.submitCallback(resp)
            })
          }
        }
      })
    },
    submitCallback(resp) {
      if (resp.status === 200) {
        this.dialogVisible = false
        this.fetchData()
        this.$message.success(resp.data.message)
      }
    },
    deleteJob(val) {
      handleConfirm('此操作将永久删除此职务, 是否继续?').then(() => {
        remove(val).then(resp => {
          this.submitCallback(resp)
        })
      })
    },
    toEditJob(val) {
      this.getEcho()
      this.dialogVisible = true
      if (val) {
        this.isEdit = true
        get(val).then(resp => {
          this.form = resp.data.result
          this.parentIdEcho = this.form.parentIds.split(',').map(h => {
            return +h
          })
        })
      } else {
        this.isEdit = false
        this.form = {}
        this.parentIdEcho = [0]
      }
    },
    getEcho() {
      fetchList().then(resp => {
        this.options = resp.data.result
        this.options.push({ name: '根节点', id: 0 })
      })
    }
  },
  data() {
    return {
      options: [],
      props: {
        value: 'id',
        label: 'name',
        children: 'childrens'
      },
      form: {},
      rules: {
        name: [
          { required: true, message: '请输入职务名称', trigger: 'blur' },
          { min: 1, max: 10, message: '长度在 1 到 10 个字符', trigger: 'blur' }
        ]
      },
      parentIdEcho: [0],
      dialogVisible: false,
      isEdit: false,
      jobList: []
    }
  }
}
</script>

<style scoped></style>
